module.exports = __webpack_public_path__ + "images/emoji/smirk.6d4eb5471b1c8cc2e532.png";